import React, { useState, useEffect, useCallback } from 'react';

// ── 💰 Abas novas da Central Financeira (12/08/2026) ─────────────────────────
// Conciliação (extrato OFX/CSV), Recorrências, DRE com fechamento, Fluxo de
// caixa projetado e Contas bancárias. A aba Lançamentos (contas a pagar/
// receber) continua no Financeiro.js — aqui é só o que nasceu no sprint.

const token = () => localStorage.getItem('token');
const apiGet = (p) => fetch(`/${p}${p.includes('?') ? '&' : '?'}_=${Date.now()}`, { headers: { Authorization: `Bearer ${token()}`, 'Cache-Control': 'no-cache' } }).then(r => r.json());
const apiSend = (p, m, b) => fetch(`/${p}`, { method: m, headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` }, body: b ? JSON.stringify(b) : undefined }).then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(d.erro || `Erro ${r.status}`); return d; });

const moeda = (v) => (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const fmtData = (iso) => { const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || ''); return m ? `${m[3]}/${m[2]}` : '—'; };
const inp = { padding: '4px 8px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', background: '#fff', height: 30, boxSizing: 'border-box' };
const lbl = { fontSize: 11, fontWeight: 600, color: '#6b7280', display: 'block', marginBottom: 2 };
const btn = (cor = '#0a1628') => ({ background: cor, color: '#fff', border: 'none', borderRadius: 4, padding: '5px 14px', fontSize: 12.5, fontWeight: 600, cursor: 'pointer' });
const caixa = { background: '#fff', border: '1px solid #c8d0da', borderRadius: 6, padding: '12px 14px', marginBottom: 12 };

// ═══ 🏦 CONTAS BANCÁRIAS ═════════════════════════════════════════════════════
export function AbaContas() {
  const [contas, setContas] = useState(null);
  const [nova, setNova] = useState({ nome: '', banco: '', tipo: 'PJ' });
  const carregar = useCallback(() => { apiGet('financeiro/contas').then(setContas).catch(() => setContas([])); }, []);
  useEffect(() => { carregar(); }, [carregar]);

  async function criar() {
    if (!nova.nome.trim()) return alert('Dê um nome pra conta (ex.: BB PJ, Nubank PF).');
    try { await apiSend('financeiro/contas', 'POST', nova); setNova({ nome: '', banco: '', tipo: 'PJ' }); carregar(); }
    catch (e) { alert(e.message); }
  }
  async function excluir(c) {
    if (!window.confirm(`Remover a conta "${c.nome}"?`)) return;
    try { await apiSend(`financeiro/contas/${c._id}`, 'DELETE'); carregar(); } catch (e) { alert(e.message); }
  }

  return (
    <div>
      <div style={caixa}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>Nova conta bancária</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div style={{ flex: 2, minWidth: 150 }}><label style={lbl}>Nome</label><input value={nova.nome} onChange={e => setNova({ ...nova, nome: e.target.value })} placeholder="Ex.: BB PJ, Nubank PF" style={{ ...inp, width: '100%' }} /></div>
          <div style={{ flex: 1, minWidth: 110 }}><label style={lbl}>Banco</label><input value={nova.banco} onChange={e => setNova({ ...nova, banco: e.target.value })} placeholder="Ex.: Banco do Brasil" style={{ ...inp, width: '100%' }} /></div>
          <div><label style={lbl}>Tipo</label>
            <select value={nova.tipo} onChange={e => setNova({ ...nova, tipo: e.target.value })} style={inp}><option>PJ</option><option>PF</option></select>
          </div>
          <button onClick={criar} style={btn('#16a34a')}>Adicionar</button>
        </div>
        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 6 }}>As contas alimentam a aba Conciliação — cada extrato importado fica etiquetado com a conta de origem. Os saldos do Capital seguem na página Capital.</div>
      </div>

      {!contas ? <div style={{ color: '#6b7280', fontSize: 13 }}>Carregando…</div> : contas.length === 0 ? (
        <div style={{ color: '#6b7280', fontSize: 13, padding: 8 }}>Nenhuma conta ainda — cadastre acima as contas PJ e PF que recebem/pagam pela empresa.</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, background: '#fff', border: '1px solid #c8d0da', borderRadius: 6 }}>
          <thead><tr style={{ background: '#0a1628' }}>{['Conta', 'Banco', 'Tipo', 'Transações', 'Pendentes', 'Última importação', ''].map((h, i) => <th key={i} style={{ padding: '5px 10px', color: '#fff', fontSize: 11, textAlign: 'left' }}>{h}</th>)}</tr></thead>
          <tbody>
            {contas.map((c, i) => (
              <tr key={c._id} style={{ background: i % 2 ? '#fafafa' : '#fff', borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '5px 10px', fontWeight: 700 }}>{c.nome}</td>
                <td style={{ padding: '5px 10px', color: '#6b7280' }}>{c.banco || '—'}</td>
                <td style={{ padding: '5px 10px' }}><span style={{ fontSize: 10.5, fontWeight: 700, padding: '1px 8px', borderRadius: 8, background: c.tipo === 'PJ' ? '#eff6ff' : '#fef9c3', color: c.tipo === 'PJ' ? '#1d4ed8' : '#854d0e' }}>{c.tipo}</span></td>
                <td style={{ padding: '5px 10px' }}>{c.transacoes || 0}</td>
                <td style={{ padding: '5px 10px', fontWeight: c.pendentes ? 700 : 400, color: c.pendentes ? '#b45309' : '#6b7280' }}>{c.pendentes || 0}</td>
                <td style={{ padding: '5px 10px', color: '#6b7280' }}>{c.ultima_importacao ? fmtData(c.ultima_importacao) : '—'}</td>
                <td style={{ padding: '5px 10px' }}><button onClick={() => excluir(c)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc2626', fontSize: 13 }}>🗑️</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

// ═══ 🏦 CONCILIAÇÃO ══════════════════════════════════════════════════════════
export function AbaConciliacao({ categorias = [] }) {
  const [contas, setContas] = useState([]);
  const [contaSel, setContaSel] = useState('');
  const [dados, setDados] = useState(null);
  const [importando, setImportando] = useState(false);
  const [lancando, setLancando] = useState(null); // transacao em lançamento manual
  const [catLanc, setCatLanc] = useState({ categoria: '', sempre: false });

  const carregar = useCallback(() => {
    apiGet(`financeiro/conciliacao${contaSel ? `?conta_id=${contaSel}` : ''}`).then(setDados).catch(() => setDados({ erro: true }));
  }, [contaSel]);
  useEffect(() => { apiGet('financeiro/contas').then(setContas).catch(() => {}); }, []);
  useEffect(() => { carregar(); }, [carregar]);

  async function importar(ev) {
    const file = ev.target.files?.[0];
    ev.target.value = '';
    if (!file) return;
    if (!contaSel) return alert('Escolha primeiro a CONTA de onde veio esse extrato.');
    setImportando(true);
    try {
      // OFX de banco costuma vir em latin1 — ler certo evita acento quebrado
      const conteudo = await new Promise((res, rej) => {
        const fr = new FileReader();
        fr.onload = () => res(fr.result); fr.onerror = rej;
        fr.readAsText(file, /\.ofx$/i.test(file.name) ? 'ISO-8859-1' : 'UTF-8');
      });
      const r = await apiSend('financeiro/extrato/importar', 'POST', { conta_id: contaSel, conteudo, nome_arquivo: file.name });
      alert(`Extrato ${r.formato}: ${r.novas} transação(ões) nova(s) · ${r.repetidas} repetida(s)${r.auto_ignoradas ? ` · ${r.auto_ignoradas} ignorada(s) por regra` : ''}${r.auto_lancadas ? ` · ${r.auto_lancadas} lançada(s) automático` : ''}`);
      carregar();
    } catch (e) { alert('Erro: ' + e.message); }
    setImportando(false);
  }

  const agir = (fn) => fn().then(carregar).catch(e => alert(e.message));
  const conciliar = (t, s) => agir(() => apiSend('financeiro/conciliacao/confirmar', 'POST', { transacao_id: t._id, lancamento_id: s.id }));
  const ignorar = (t, sempre) => agir(() => apiSend('financeiro/conciliacao/ignorar', 'POST', { transacao_id: t._id, sempre }));
  const lancar = (t) => agir(() => apiSend('financeiro/conciliacao/lancar', 'POST', { transacao_id: t._id, categoria: catLanc.categoria, sempre: catLanc.sempre })).then(() => setLancando(null));

  const cont = dados?.contadores || {};
  return (
    <div>
      <div style={{ ...caixa, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div style={{ minWidth: 200 }}>
          <label style={lbl}>Conta do extrato</label>
          <select value={contaSel} onChange={e => setContaSel(e.target.value)} style={{ ...inp, width: '100%' }}>
            <option value="">— todas / escolher —</option>
            {contas.map(c => <option key={c._id} value={c._id}>{c.nome} ({c.tipo})</option>)}
          </select>
        </div>
        <label style={{ ...btn('#1d4ed8'), display: 'inline-block', opacity: importando ? .6 : 1 }}>
          {importando ? 'Importando…' : '📥 Importar extrato (OFX/CSV)'}
          <input type="file" accept=".ofx,.csv,.txt" onChange={importar} style={{ display: 'none' }} disabled={importando} />
        </label>
        <div style={{ fontSize: 12, color: '#6b7280', display: 'flex', gap: 12 }}>
          <span>⏳ pendentes: <b>{cont.pendente ?? '—'}</b></span>
          <span>✅ conciliadas: <b>{cont.conciliado ?? '—'}</b></span>
          <span>📝 lançadas: <b>{cont.lancado ?? '—'}</b></span>
          <span>🙈 ignoradas: <b>{cont.ignorado ?? '—'}</b></span>
        </div>
      </div>

      {!dados ? <div style={{ color: '#6b7280', fontSize: 13 }}>Carregando…</div>
        : dados.erro ? <div style={{ color: '#b91c1c', fontSize: 13 }}>Erro ao carregar.</div>
        : !dados.transacoes.length ? (
          <div style={{ color: '#6b7280', fontSize: 13, padding: 10, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6 }}>
            🎉 Nenhuma transação pendente — extrato conciliado. Cadastre a conta (aba Contas) e importe o próximo OFX quando quiser.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {dados.transacoes.map(t => (
              <div key={t._id} style={{ background: '#fff', border: '1px solid #dbe2ea', borderRadius: 8, padding: '10px 12px' }}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
                  <span style={{ fontSize: 11.5, color: '#6b7280', width: 42 }}>{fmtData(t.data)}</span>
                  <span style={{ flex: 1, fontSize: 13, color: '#111', minWidth: 180 }}>{t.descricao || '(sem descrição)'}</span>
                  <b style={{ color: t.tipo === 'entrada' ? '#15803d' : '#b91c1c', fontSize: 13.5 }}>{t.tipo === 'entrada' ? '+' : '−'}{moeda(t.valor)}</b>
                </div>
                {t.sugestoes?.length > 0 && (
                  <div style={{ marginTop: 6, background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 6, padding: '6px 10px', display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    <span style={{ fontSize: 12, color: '#0369a1' }}>≈ <b>{t.sugestoes[0].quem || t.sugestoes[0].descricao}</b> · venc. {fmtData(t.sugestoes[0].vencimento)} · {moeda(t.sugestoes[0].valor)}</span>
                    <button onClick={() => conciliar(t, t.sugestoes[0])} style={btn('#16a34a')}>✓ Conciliar (dar baixa)</button>
                    {t.sugestoes.length > 1 && <span style={{ fontSize: 11, color: '#6b7280' }}>+{t.sugestoes.length - 1} alternativa(s)</span>}
                  </div>
                )}
                <div style={{ marginTop: 6, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                  {lancando === t._id ? (
                    <>
                      <select value={catLanc.categoria} onChange={e => setCatLanc(p => ({ ...p, categoria: e.target.value }))} style={{ ...inp, height: 26 }}>
                        <option value="">— categoria —</option>
                        {categorias.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                      <label style={{ fontSize: 11.5, color: '#374151', display: 'flex', gap: 4, alignItems: 'center' }}>
                        <input type="checkbox" checked={catLanc.sempre} onChange={e => setCatLanc(p => ({ ...p, sempre: e.target.checked }))} /> aprender (sempre assim)
                      </label>
                      <button onClick={() => lancar(t)} style={btn('#0a1628')}>Lançar quitado</button>
                      <button onClick={() => setLancando(null)} style={{ ...btn('#fff'), color: '#374151', border: '1px solid #d1d5db' }}>Cancelar</button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => { setLancando(t._id); setCatLanc({ categoria: '', sempre: false }); }}
                        style={{ ...btn('#fff'), color: '#0a1628', border: '1px solid #c8d0da' }}>➕ Lançar avulso</button>
                      <button onClick={() => ignorar(t, false)} style={{ ...btn('#fff'), color: '#6b7280', border: '1px solid #d1d5db' }}>🙈 Ignorar</button>
                      <button onClick={() => ignorar(t, true)} title="Ignora e cria regra: transações parecidas serão ignoradas automaticamente nos próximos extratos"
                        style={{ ...btn('#fff'), color: '#6b7280', border: '1px dashed #d1d5db' }}>🙈 Ignorar sempre</button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
    </div>
  );
}

// ═══ 🔁 RECORRÊNCIAS ═════════════════════════════════════════════════════════
export function AbaRecorrencias({ categorias = [] }) {
  const [lista, setLista] = useState(null);
  const [form, setForm] = useState({ tipo: 'pagar', descricao: '', valor: '', dia_vencimento: 5, categoria: '' });
  const carregar = useCallback(() => { apiGet('financeiro/recorrencias').then(setLista).catch(() => setLista([])); }, []);
  useEffect(() => { carregar(); }, [carregar]);

  async function criar() {
    try {
      await apiSend('financeiro/recorrencias', 'POST', form);
      setForm({ tipo: 'pagar', descricao: '', valor: '', dia_vencimento: 5, categoria: '' });
      carregar();
    } catch (e) { alert(e.message); }
  }
  const alternar = (r) => apiSend(`financeiro/recorrencias/${r._id}`, 'PUT', { ativo: !r.ativo }).then(carregar).catch(e => alert(e.message));
  const excluir = (r) => { if (window.confirm(`Excluir a recorrência "${r.descricao}"? Os lançamentos já gerados ficam.`)) apiSend(`financeiro/recorrencias/${r._id}`, 'DELETE').then(carregar); };

  return (
    <div>
      <div style={caixa}>
        <div style={{ fontSize: 13, fontWeight: 700, color: '#0a1628', marginBottom: 8 }}>Nova recorrência mensal</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div><label style={lbl}>Tipo</label>
            <select value={form.tipo} onChange={e => setForm({ ...form, tipo: e.target.value })} style={inp}><option value="pagar">📤 A pagar</option><option value="receber">📥 A receber</option></select>
          </div>
          <div style={{ flex: 2, minWidth: 170 }}><label style={lbl}>Descrição</label><input value={form.descricao} onChange={e => setForm({ ...form, descricao: e.target.value })} placeholder="Ex.: Aluguel do escritório" style={{ ...inp, width: '100%' }} /></div>
          <div style={{ width: 110 }}><label style={lbl}>Valor (R$)</label><input value={form.valor} onChange={e => setForm({ ...form, valor: e.target.value })} placeholder="0,00" inputMode="numeric" style={{ ...inp, width: '100%' }} /></div>
          <div style={{ width: 70 }}><label style={lbl}>Dia</label><input type="number" min={1} max={28} value={form.dia_vencimento} onChange={e => setForm({ ...form, dia_vencimento: e.target.value })} style={{ ...inp, width: '100%' }} /></div>
          <div style={{ minWidth: 150 }}><label style={lbl}>Categoria</label>
            <select value={form.categoria} onChange={e => setForm({ ...form, categoria: e.target.value })} style={{ ...inp, width: '100%' }}>
              <option value="">—</option>{categorias.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <button onClick={criar} style={btn('#16a34a')}>Criar</button>
        </div>
        <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 6 }}>Todo mês o lançamento nasce sozinho no dia escolhido (dia 1 a 28) e aparece no contas a {form.tipo === 'pagar' ? 'pagar' : 'receber'} — sem digitar de novo.</div>
      </div>

      {!lista ? <div style={{ color: '#6b7280', fontSize: 13 }}>Carregando…</div> : lista.length === 0 ? (
        <div style={{ color: '#6b7280', fontSize: 13, padding: 8 }}>Nenhuma recorrência — cadastre as despesas fixas (aluguel, VPS, salários…) e nunca mais digite.</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, background: '#fff', border: '1px solid #c8d0da' }}>
          <thead><tr style={{ background: '#0a1628' }}>{['', 'Descrição', 'Valor', 'Dia', 'Categoria', 'Último mês gerado', 'Ativa', ''].map((h, i) => <th key={i} style={{ padding: '5px 10px', color: '#fff', fontSize: 11, textAlign: 'left' }}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.map((r, i) => (
              <tr key={r._id} style={{ background: i % 2 ? '#fafafa' : '#fff', borderBottom: '1px solid #eee', opacity: r.ativo ? 1 : .5 }}>
                <td style={{ padding: '5px 10px' }}>{r.tipo === 'receber' ? '📥' : '📤'}</td>
                <td style={{ padding: '5px 10px', fontWeight: 600 }}>{r.descricao}</td>
                <td style={{ padding: '5px 10px' }}>{moeda(r.valor)}</td>
                <td style={{ padding: '5px 10px' }}>{r.dia_vencimento}</td>
                <td style={{ padding: '5px 10px', color: '#6b7280' }}>{r.categoria || '—'}</td>
                <td style={{ padding: '5px 10px', color: '#6b7280' }}>{r.ultima_gerada || '—'}</td>
                <td style={{ padding: '5px 10px' }}>
                  <button onClick={() => alternar(r)} style={{ ...btn(r.ativo ? '#16a34a' : '#9ca3af'), padding: '2px 10px', fontSize: 11 }}>{r.ativo ? 'ATIVA' : 'pausada'}</button>
                </td>
                <td style={{ padding: '5px 10px' }}><button onClick={() => excluir(r)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#dc2626' }}>🗑️</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

// ═══ 📊 DRE COM FECHAMENTO ═══════════════════════════════════════════════════
const LINHAS_DRE = [
  ['receita', '📥 Receita', true],
  ['impostos', 'Impostos e Tributos'],
  ['custos_diretos', 'Custos diretos (INPI/GRU)'],
  ['folha', 'Folha de Pagamento'],
  ['custos_oper', 'Custos Operacionais'],
  ['fornecedores', 'Fornecedores'],
  ['marketing', 'Marketing e Vendas'],
  ['financeiras', 'Despesas Financeiras'],
  ['investimentos', 'Investimentos'],
  ['retiradas', 'Retiradas (Vagner)'],
  ['outras', 'Outras despesas'],
  ['sem_categoria', '⚠️ Sem categoria'],
];
const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

export function AbaDre() {
  const [ano, setAno] = useState(new Date().getFullYear());
  const [regime, setRegime] = useState('caixa');
  const [dados, setDados] = useState(null);
  const [fechados, setFechados] = useState([]);

  const carregar = useCallback(() => {
    apiGet(`financeiro/dre?ano=${ano}&regime=${regime}`).then(setDados).catch(() => setDados({ erro: true }));
    apiGet('financeiro/fechamentos').then(f => setFechados(Array.isArray(f) ? f : [])).catch(() => {});
  }, [ano, regime]);
  useEffect(() => { carregar(); }, [carregar]);

  const L = dados?.linhas;
  const abrev = (v) => v === 0 ? '—' : (Math.abs(v) >= 1000 ? (v / 1000).toFixed(1) + 'k' : Math.round(v));
  const resultado = L ? MESES.map((_, m) => L.receita[m] - LINHAS_DRE.slice(1).reduce((s, [k]) => s + L[k][m], 0)) : [];
  const totalAno = (arr) => arr.reduce((s, v) => s + v, 0);
  const mesKey = (m) => `${ano}-${String(m + 1).padStart(2, '0')}`;

  async function alternarFechamento(m) {
    const chave = mesKey(m);
    try {
      if (fechados.includes(chave)) {
        if (!window.confirm(`Reabrir ${MESES[m]}/${ano}? Os lançamentos do mês voltam a ser editáveis.`)) return;
        await apiSend(`financeiro/fechamentos/${chave}`, 'DELETE');
      } else {
        if (!window.confirm(`Fechar ${MESES[m]}/${ano}? Lançamentos do mês ficam TRAVADOS (sem editar, baixar ou excluir) até reabrir.`)) return;
        await apiSend('financeiro/fechamentos', 'POST', { mes: chave });
      }
      carregar();
    } catch (e) { alert(e.message); }
  }

  return (
    <div>
      <div style={{ ...caixa, display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap' }}>
        <select value={ano} onChange={e => setAno(parseInt(e.target.value, 10))} style={inp}>
          {(dados?.anos?.length ? dados.anos : [ano]).map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        {['caixa', 'competencia'].map(r => (
          <button key={r} onClick={() => setRegime(r)} style={{ ...btn(regime === r ? '#0a1628' : '#fff'), color: regime === r ? '#fff' : '#374151', border: '1px solid #d1d5db' }}>
            {r === 'caixa' ? '💵 Caixa (pago/recebido)' : '📅 Competência (vencimento)'}
          </button>
        ))}
        {dados?.alerta_sem_categoria > 0 && <span style={{ fontSize: 12, color: '#b45309' }}>⚠️ {dados.alerta_sem_categoria} lançamento(s) sem categoria — categorize pra um DRE limpo</span>}
      </div>

      {!dados ? <div style={{ color: '#6b7280', fontSize: 13 }}>Carregando…</div> : dados.erro ? <div style={{ color: '#b91c1c' }}>Erro.</div> : (
        <div style={{ overflowX: 'auto', background: '#fff', border: '1px solid #c8d0da', borderRadius: 6 }}>
          <table style={{ borderCollapse: 'collapse', fontSize: 12, minWidth: 900, width: '100%' }}>
            <thead>
              <tr style={{ background: '#0a1628' }}>
                <th style={{ padding: '5px 10px', color: '#fff', fontSize: 11, textAlign: 'left', position: 'sticky', left: 0, background: '#0a1628' }}>Linha</th>
                {MESES.map((m, i) => (
                  <th key={m} style={{ padding: '5px 6px', color: '#fff', fontSize: 11, textAlign: 'right', whiteSpace: 'nowrap' }}>
                    {m} <button onClick={() => alternarFechamento(i)} title={fechados.includes(mesKey(i)) ? 'Mês FECHADO — clique pra reabrir' : 'Clique pra FECHAR o mês (trava edição)'}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 11, padding: 0 }}>{fechados.includes(mesKey(i)) ? '🔒' : '🔓'}</button>
                  </th>
                ))}
                <th style={{ padding: '5px 8px', color: '#fff', fontSize: 11, textAlign: 'right' }}>Ano</th>
              </tr>
            </thead>
            <tbody>
              {LINHAS_DRE.map(([k, rotulo, ehReceita]) => L && (
                <tr key={k} style={{ borderBottom: '1px solid #eee', background: ehReceita ? '#f0fdf4' : '#fff' }}>
                  <td style={{ padding: '4px 10px', fontWeight: ehReceita ? 800 : 500, whiteSpace: 'nowrap', position: 'sticky', left: 0, background: ehReceita ? '#f0fdf4' : '#fff' }}>{rotulo}</td>
                  {MESES.map((_, m) => <td key={m} style={{ padding: '4px 6px', textAlign: 'right', color: ehReceita ? '#15803d' : '#374151' }}>{abrev(L[k][m])}</td>)}
                  <td style={{ padding: '4px 8px', textAlign: 'right', fontWeight: 700 }}>{abrev(totalAno(L[k]))}</td>
                </tr>
              ))}
              {L && (
                <>
                  <tr style={{ background: '#0a1628' }}>
                    <td style={{ padding: '5px 10px', fontWeight: 800, color: '#fff', position: 'sticky', left: 0, background: '#0a1628' }}>💰 Resultado</td>
                    {resultado.map((v, m) => <td key={m} style={{ padding: '5px 6px', textAlign: 'right', fontWeight: 800, color: v >= 0 ? '#4ade80' : '#f87171' }}>{abrev(v)}</td>)}
                    <td style={{ padding: '5px 8px', textAlign: 'right', fontWeight: 800, color: totalAno(resultado) >= 0 ? '#4ade80' : '#f87171' }}>{abrev(totalAno(resultado))}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '4px 10px', fontWeight: 700, color: '#6b7280', position: 'sticky', left: 0, background: '#fff' }}>Margem %</td>
                    {resultado.map((v, m) => <td key={m} style={{ padding: '4px 6px', textAlign: 'right', color: '#6b7280' }}>{L.receita[m] ? Math.round(v / L.receita[m] * 100) + '%' : '—'}</td>)}
                    <td style={{ padding: '4px 8px', textAlign: 'right', color: '#6b7280', fontWeight: 700 }}>{totalAno(L.receita) ? Math.round(totalAno(resultado) / totalAno(L.receita) * 100) + '%' : '—'}</td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
      )}
      <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 8 }}>🔒 Mês fechado = lançamentos travados (editar/baixar/excluir barrados até reabrir). Valores em milhares (k) quando grandes.</div>
    </div>
  );
}

// ═══ 💸 FLUXO DE CAIXA PROJETADO ═════════════════════════════════════════════
export function AbaFluxo() {
  const [dados, setDados] = useState(null);
  const [saldoTmp, setSaldoTmp] = useState('');
  const carregar = useCallback(() => { apiGet('financeiro/fluxo?dias=90').then(setDados).catch(() => setDados({ erro: true })); }, []);
  useEffect(() => { carregar(); }, [carregar]);

  async function salvarSaldo() {
    try { await apiSend('financeiro/fluxo/saldo-base', 'PUT', { valor: saldoTmp }); setSaldoTmp(''); carregar(); }
    catch (e) { alert(e.message); }
  }

  const linhas = dados?.linhas || [];
  const maxAbs = Math.max(1, ...linhas.map(l => Math.abs(l.saldo)));
  const cardProj = (rotulo, v) => (
    <div style={{ flex: 1, minWidth: 130, background: v >= 0 ? '#f0fdf4' : '#fef2f2', border: `1px solid ${v >= 0 ? '#bbf7d0' : '#fca5a5'}`, borderRadius: 8, padding: '10px 12px' }}>
      <div style={{ fontSize: 10.5, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>{rotulo}</div>
      <div style={{ fontSize: 19, fontWeight: 800, color: v >= 0 ? '#15803d' : '#b91c1c' }}>{moeda(v)}</div>
    </div>
  );

  return (
    <div>
      <div style={{ ...caixa, display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div>
          <label style={lbl}>Saldo em caixa HOJE (somando as contas)</label>
          <input value={saldoTmp} onChange={e => setSaldoTmp(e.target.value)} placeholder={dados?.saldo_base ? moeda(dados.saldo_base) : '0,00'} inputMode="numeric" style={{ ...inp, width: 160 }} />
        </div>
        <button onClick={salvarSaldo} style={btn()}>Atualizar saldo</button>
        {dados?.saldo_base_em && <span style={{ fontSize: 11.5, color: '#9ca3af' }}>informado em {fmtData(dados.saldo_base_em)} — a projeção parte dele</span>}
      </div>

      {!dados ? <div style={{ color: '#6b7280', fontSize: 13 }}>Carregando…</div> : dados.erro ? <div style={{ color: '#b91c1c' }}>Erro.</div> : (
        <>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
            {cardProj('Hoje (informado)', dados.saldo_base)}
            {cardProj('Em 30 dias', dados.projecao.d30)}
            {cardProj('Em 60 dias', dados.projecao.d60)}
            {cardProj('Em 90 dias', dados.projecao.d90)}
          </div>

          {linhas.length === 0 ? (
            <div style={{ color: '#6b7280', fontSize: 13 }}>Nada previsto no horizonte — cadastre parcelas e recorrências.</div>
          ) : (
            <div style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 6, padding: '10px 12px' }}>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', marginBottom: 6 }}>Saldo projetado dia a dia (90d)</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 2, height: 70 }}>
                {linhas.map(l => (
                  <div key={l.data} title={`${fmtData(l.data)}: +${moeda(l.entrada)} −${moeda(l.saida)} → saldo ${moeda(l.saldo)}`}
                    style={{ flex: 1, maxWidth: 16, background: l.saldo >= 0 ? '#16a34a' : '#dc2626', opacity: .8, borderRadius: 2, height: `${Math.max(6, Math.abs(l.saldo) / maxAbs * 100)}%`, alignSelf: l.saldo >= 0 ? 'flex-end' : 'flex-start' }} />
                ))}
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5, marginTop: 10 }}>
                <thead><tr style={{ background: '#0a1628' }}>{['Data', 'Entradas', 'Saídas', 'Saldo projetado'].map((h, i) => <th key={h} style={{ padding: '4px 8px', color: '#fff', fontSize: 11, textAlign: i ? 'right' : 'left' }}>{h}</th>)}</tr></thead>
                <tbody>
                  {linhas.slice(0, 25).map((l, i) => (
                    <tr key={l.data} style={{ background: i % 2 ? '#fafafa' : '#fff', borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '3px 8px' }}>{fmtData(l.data)}</td>
                      <td style={{ padding: '3px 8px', textAlign: 'right', color: '#15803d' }}>{l.entrada ? moeda(l.entrada) : '—'}</td>
                      <td style={{ padding: '3px 8px', textAlign: 'right', color: '#b91c1c' }}>{l.saida ? moeda(l.saida) : '—'}</td>
                      <td style={{ padding: '3px 8px', textAlign: 'right', fontWeight: 700, color: l.saldo >= 0 ? '#0a1628' : '#b91c1c' }}>{moeda(l.saldo)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {linhas.length > 25 && <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4 }}>… e mais {linhas.length - 25} dias no gráfico acima (passa o mouse).</div>}
            </div>
          )}
          <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 8 }}>Projeção = saldo informado + parcelas em aberto por vencimento + recorrências futuras. Parcela atrasada conta como entrada/saída de hoje.</div>
        </>
      )}
    </div>
  );
}

// ═══ 🕵️ AUDITORIA ════════════════════════════════════════════════════════════
// Trilha de quem fez o quê no financeiro (só o administrador enxerga).
// Nasceu do caso da parcela que "sumiu" de setembro sem dono conhecido.
const CORES_ACAO = {
  excluiu: ['#b91c1c', '#fef2f2', '#fecaca'],
  editou: ['#b45309', '#fffbeb', '#fde68a'],
  criou: ['#15803d', '#f0fdf4', '#bbf7d0'],
  baixa: ['#1d4ed8', '#eff6ff', '#bfdbfe'],
  estorno: ['#7c3aed', '#f5f3ff', '#ddd6fe'],
  fechou_mes: ['#0a1628', '#f1f5f9', '#cbd5e1'],
  reabriu_mes: ['#0a1628', '#f1f5f9', '#cbd5e1'],
};
export function AbaAuditoria() {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [f, setF] = useState({ acao: '', busca: '' });
  const [aberto, setAberto] = useState(null);

  const carregar = useCallback(() => {
    const qs = new URLSearchParams({ limite: '300', ...(f.acao ? { acao: f.acao } : {}), ...(f.busca ? { busca: f.busca } : {}) });
    apiGet(`auditoria?${qs}`).then(d => { if (d.erro) setErro(d.erro); else { setErro(''); setDados(d); } }).catch(e => setErro(e.message));
  }, [f]);
  useEffect(() => { carregar(); }, [carregar]);

  const fmtQuando = (iso) => {
    const d = new Date(iso);
    return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  };

  if (erro) return <div style={{ ...caixa, color: '#b91c1c', fontSize: 13 }}>{erro}</div>;
  return (
    <div>
      <div style={{ ...caixa, display: 'flex', gap: 10, alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <div>
          <label style={lbl}>Ação</label>
          <select value={f.acao} onChange={e => setF(x => ({ ...x, acao: e.target.value }))} style={inp}>
            <option value="">Todas</option>
            <option value="excluiu">🗑️ Exclusões</option>
            <option value="editou">✏️ Edições</option>
            <option value="criou">➕ Criações</option>
            <option value="baixa">💰 Baixas</option>
            <option value="estorno">↩️ Estornos</option>
            <option value="fechou_mes">🔒 Fechamento de mês</option>
            <option value="reabriu_mes">🔓 Reabertura de mês</option>
          </select>
        </div>
        <div style={{ flex: 1, minWidth: 200 }}>
          <label style={lbl}>Buscar (descrição, pessoa, cliente…)</label>
          <input value={f.busca} onChange={e => setF(x => ({ ...x, busca: e.target.value }))} placeholder="Ex: ARINELSON, parcela, R$ 1000…" style={{ ...inp, width: '100%' }} />
        </div>
        <div style={{ fontSize: 11.5, color: '#6b7280', paddingBottom: 6 }}>{dados ? `${dados.total} registro(s)` : '…'}</div>
      </div>

      <div style={{ ...caixa, padding: 0, overflow: 'hidden' }}>
        {(dados?.itens || []).length === 0 && (
          <div style={{ padding: 16, fontSize: 12.5, color: '#6b7280' }}>Nenhum registro ainda — a trilha começou a gravar em 27/08/2026. Toda exclusão, edição, baixa, estorno e fechamento de mês do financeiro aparece aqui daqui pra frente.</div>
        )}
        {(dados?.itens || []).map(i => {
          const [cor, fundo, borda] = CORES_ACAO[i.acao] || ['#374151', '#f9fafb', '#e5e7eb'];
          const temDetalhe = i.antes || i.depois;
          return (
            <div key={i._id} style={{ borderBottom: '1px solid #eef1f5' }}>
              <div onClick={() => temDetalhe && setAberto(a => a === i._id ? null : i._id)}
                style={{ display: 'flex', gap: 10, alignItems: 'center', padding: '7px 14px', cursor: temDetalhe ? 'pointer' : 'default', flexWrap: 'wrap' }}>
                <span style={{ fontSize: 11, color: '#6b7280', whiteSpace: 'nowrap', width: 100 }}>{fmtQuando(i.quando)}</span>
                <span style={{ fontSize: 10.5, fontWeight: 800, color: cor, background: fundo, border: `1px solid ${borda}`, borderRadius: 8, padding: '1px 8px', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>{(i.acao || '').replace('_', ' ')}</span>
                <span style={{ fontSize: 12, fontWeight: 700, color: '#0a1628', whiteSpace: 'nowrap' }}>{i.quem || i.email || '?'}</span>
                <span style={{ fontSize: 12, color: '#374151', flex: 1, minWidth: 220 }}>{i.descricao}</span>
                {temDetalhe && <span style={{ fontSize: 11, color: '#9ca3af' }}>{aberto === i._id ? '▲' : '▼ detalhes'}</span>}
              </div>
              {aberto === i._id && (
                <pre style={{ margin: 0, padding: '8px 14px 12px 124px', fontSize: 11, color: '#334155', background: '#f8fafc', overflowX: 'auto', whiteSpace: 'pre-wrap' }}>
                  {JSON.stringify({ antes: i.antes || undefined, depois: i.depois || undefined }, null, 2)}
                </pre>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
